<template>
  <el-dialog
    title="发货信息"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
      :disabled="model.read"
      class="delivery"
    >
      <el-form-item label="发货时间" prop="deliver_time">
        <el-date-picker
          v-model="model.deliver_time"
          type="date"
          placeholder="选择日期"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发货人" prop="deliver_contact">
        <el-input v-model="model.deliver_contact"></el-input>
      </el-form-item>
      <el-form-item label="发货方式" prop="deliver_company">
        <el-input v-model="model.deliver_company"></el-input>
      </el-form-item>
      <el-form-item label="物流单号" prop="deliver_number">
        <el-input v-model="model.deliver_number"></el-input>
      </el-form-item>

      <el-form-item label="收货人" prop="receive_contact">
        <el-input v-model="model.receive_contact"></el-input>
      </el-form-item>
      <el-form-item label="收货地址" prop="receive_adress">
        <el-input v-model="model.receive_adress"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer" v-show="!model.read">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  deliveryCreate,
  deliveryUpdate,
  deliveryDetailBySubject,
} from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      } else {
        if (this.model.read) {
          this.getDeliveryDetail()
        }
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        serial_number: [{ required: true, message: '请输入钻头序列号' }],
      },
    }
  },
  methods: {
    async getDeliveryDetail() {
      let res = await deliveryDetailBySubject(this.model)
      if (res.status == 0) {
        this.$set(this.model, 'id', res.data.id)
        this.$set(this.model, 'deliver_time', res.data.deliver_time)
        this.$set(this.model, 'deliver_contact', res.data.deliver_contact)
        this.$set(this.model, 'deliver_company', res.data.deliver_company)
        this.$set(this.model, 'deliver_number', res.data.deliver_number)
        this.$set(this.model, 'receive_contact', res.data.receive_contact)
        this.$set(this.model, 'receive_adress', res.data.receive_adress)
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id) {
            let res = await deliveryUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await deliveryCreate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style>
.delivery .el-input.is-disabled .el-input__inner {
  color: #606266 !important;
}
</style>